<div mat-dialog-title class="title-container">
  <h2>{{ 'building.control.title' | transloco }}</h2>
</div>

<mat-dialog-content class="flex-column">
  @if (addresses$ | async; as addresses) {
  <div class="building-address">
    @if (addresses.length > 0) {
    <p>{{ addresses[0] }}</p>
    } @else {
    <p>{{ 'building.addressNotAvailable' | transloco }}</p>
    }
  </div>
  }
  <div class="content">
    <h3>{{ 'building.control.defectsCompliance.title' | transloco }}</h3>

    @if (defectsInEdition$ | async; as selection) { @if (selection.length > 0) {
    <sibat-control-defect-compliance-form
      [controlId]="controlId"
      [defects]="selection"
      [thumbnails]="thumbnails"
    ></sibat-control-defect-compliance-form>
    } }

    <div class="list">
      @for (defect of defects$ | async; track trackById($index, defect)) {
      <sibat-control-defect-item
        data-testid="control-list-defect-item"
        [defect]="defect"
        [thumbnails]="thumbnails"
        [controlId]="controlId"
        class="list-item"
      >
      </sibat-control-defect-item>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <sibat-secondary-button
    data-testid="control-defect-list-close-button"
    class="mat-button-base"
    (click)="close()"
    [label]="'layout.closeDialog' | transloco"
  >
  </sibat-secondary-button>
</mat-dialog-actions>
